/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

export { PreviewTemplateContainer as PreviewTemplate } from './PreviewTemplate.container';
